import React, {useEffect,useState} from 'react'
import './Dark.css';
const Dark = () => {
    const [darkTheme, setDarkTheme] = useState('light-theme');
    const change=()=> {
        if(darkTheme==='light-theme')
        setDarkTheme('dark');
        else
        setDarkTheme('light-theme');
    }
    useEffect(() => {
      document.body.className=darkTheme;
      console.log(document.body.className);
    }, [darkTheme]);
    

  return (
    <>
        <div className="content mt-3">
        <i className="fas fa-sun"></i>
        &nbsp;&nbsp;&nbsp;
        <input type="checkbox" id="tooglenight" className="cbx hidden" onClick={()=>change()} />
        <label for="tooglenight" className="switch"></label>
        &nbsp;&nbsp;&nbsp;
        <i class="fas fa-moon"></i>
    </div>
    </>
  )
}

export default Dark